import { render, staticRenderFns } from "./district.vue?vue&type=template&id=81ff64b6&scoped=true"
import script from "./district.vue?vue&type=script&lang=js"
export * from "./district.vue?vue&type=script&lang=js"
import style0 from "./district.vue?vue&type=style&index=0&id=81ff64b6&prod&lang=scss&scoped=true"
import style1 from "./district.vue?vue&type=style&index=1&id=81ff64b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ff64b6",
  null
  
)

export default component.exports